import type { OptionValue } from '@tempmee/core';
import { useMemo } from 'react';
import { toParkingTypeOptions } from '~/constants/officeProfileOptions';
import { useAppSelector } from './useAppSelector';

/** The parking-type picker's options: `allMetadata.parkingTypes`, or the fallback until it loads. */
export const useParkingTypeOptions = (): OptionValue<string>[] => {
  const parkingTypesFromMetadata = useAppSelector(
    (state) => (state.user.allMetadata as { parkingTypes?: string[] } | null)?.parkingTypes,
  );

  return useMemo(() => toParkingTypeOptions(parkingTypesFromMetadata), [parkingTypesFromMetadata]);
};
